import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { IItemDetailState } from './models';

const selectItemDetailState = (state: RootState): IItemDetailState => state.itemDetail;

export const selectItem = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.item : null
);

export const selectItemResponse = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.itemResponse : null
);

export const selectItemResponseLoaded = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.loadedResponse : null
);

export const selectItemResponseLoading = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.loadingResponse : null
);

export const selectItemScoreGuide = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.itemScoreGuide : null
);

export const selectItemScoreGuideLoaded = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.loadedScoreGuide : null
);

export const selectItemScoreGuideLoading = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.loadingScoreGuide : null
);

export const selectItemSampleResponses = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.itemSampleResponses : null
);


export const selectItemSampleResponsesLoaded = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.loadedSampleResponses : null
);

export const selectItemSampleResponsesLoading = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.loadingSampleResponses : null
);

export const selectItemPerformanceData = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.itemPerformanceData : null
);


export const selectItemPerformanceDataLoaded = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.loadedPerformanceData : null
);

export const selectItemPerformanceDataLoading = createSelector(
  [selectItemDetailState],
  (state: IItemDetailState) => state ? state.loadingPerformanceData : null
);


